import { render, staticRenderFns } from "./InvitePage.vue?vue&type=template&id=97eba952&scoped=true"
import script from "./InvitePage.vue?vue&type=script&lang=js"
export * from "./InvitePage.vue?vue&type=script&lang=js"
import style0 from "./InvitePage.vue?vue&type=style&index=0&id=97eba952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eba952",
  null
  
)

export default component.exports